import React from 'react';

function AtaFinalModal({ show, onClose, onSubmit, form, setForm }) {
  if (!show) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.data || !form.hora) {
      alert('Preencha data e hora');
      return;
    }
    const anoLocal = localStorage.getItem('ano') || new Date().getFullYear();
    onSubmit({ ano: Number(anoLocal), data: form.data, hora: form.hora });
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055 }}>
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-success text-white">
            <h6 className="modal-title small">Cadastro Ata Final</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              {/* Ano vem do localStorage; não exibir campo aqui */}
              <div className="mb-2">
                <label className="form-label">Data *</label>
                <input type="date" name="data" className="form-control" value={form.data} onChange={handleChange} required />
              </div>
              <div className="mb-2">
                <label className="form-label">Hora *</label>
                <input type="time" name="hora" className="form-control" value={form.hora} onChange={handleChange} required />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
              <button type="submit" className="btn btn-success">Salvar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AtaFinalModal;
